import React, { useState, useEffect } from 'react'
import uniqueId from 'lodash/uniqueId'
import '../../assets/css/components/Inputs/Switch.css'

const Switch: React.FC<SwitchProps> = ({
  label,
  register,
  value,
  name,
  onChange,
  icon,
  small = false,
  disabled = false,
  containerClasses,
  switchClasses,
  forForm = false,
  ...props
}) => {
  const uid = uniqueId('label-')
  const [on, setOn] = useState(value)
  // const controlledProps = value ? { checked: value } : {};
  useEffect(() => {
    setOn(value)
  }, [value])

  return (
    <div className={`flex items-center w-max ${containerClasses}`}>
      <div className="relative flex mr-2 align-middle select-none transition duration-200 ease-in">
        <input
          disabled={disabled}
          type="checkbox"
          checked={on}
          onChange={(e) => {
            if (onChange) onChange(e.target.checked)
          }}
          name={name}
          id={uid}
          ref={register ? register() : undefined}
          className={`appearance-none toggle-checkbox ${
            small ? 'w-8 h-4' : 'w-10 h-6'
          } border-none transition-all rounded-full ${forForm && 'bg-primaryGray-300'} dark:bg-primary-600 appearance-none cursor-pointer ${switchClasses}`}
        />
        <label
          htmlFor={uid}
          className={`toggle-label ${
            small ? 'w-3 h-3' : 'w-5 h-5'
          } transition-all absolute m-auto text-center rounded-full shadow-sm ${forForm && 'bg-white'}  dark:bg-black cursor-pointer`}
        >
          <div className="flex justify-center items-center h-full w-full text-primary dark:text-white">
            {icon}
          </div>
        </label>
      </div>
      <label
        htmlFor={uid}
        className={`font-medium text-primary-900 text-xs cursor-pointer dark:text-white select-none`}
      >
        {label || ''}
      </label>
    </div>
  )
}

export default Switch
interface SwitchProps {
  icon?: JSX.Element
  label?: string
  register?: Function
  name?: string
  small?: boolean
  onChange?: Function
  value?: boolean
  containerClasses?: string
  disabled?: boolean
  switchClasses?: string
  forForm?: boolean
}
